export default function isBrowser() {
  try {
    return window !== undefined;
  } catch {
    return false;
  }
}
